<template>
  <div class="container" v-if="lookups">
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
        <div class="row">
          <div class="col-md-12">
            <b-card>

              <SubHeader title="Create Company" />
              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="tradingAsName">Registered Name</label>
                </b-col>
                <b-col md="5">
                  <validation-provider name="Registered Name"
                                       :rules="{ required: true }"
                                       v-slot="validationContext">
                    <b-form-input id="companyName"
                                  v-model="company.companyName"
                                  :state="getValidationState(validationContext)"></b-form-input>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="tradingAsName">Trading As</label>
                </b-col>
                <b-col md="5">
                  <b-form-input id="tradingAsName"
                                v-model="company.tradingAsName"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="tradingAsName">Company Number</label>
                </b-col>
                <b-col md="3">
                  <validation-provider name="registeredNumber"
                                       rules="registeredNumberUnknown:@registeredNumber,@registeredNumberUnknown"
                                       v-slot="validationContext">
                    <b-form-input id="registeredNumber"
                                  v-model="company.registeredNumber"
                                  :state="getValidationState(validationContext)"></b-form-input>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider name="registeredNumberUnknown"
                                       rules="registeredNumberUnknown:@registeredNumber,@registeredNumberUnknown"
                                       v-slot="validationContext">
                    <b-form-checkbox name="registeredNumberUnknown"
                                     v-model="company.registeredNumberUnknown"
                                     :state="getValidationState(validationContext)">Registered Number Unknown</b-form-checkbox>
                  </validation-provider>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="tradingAsName">Established Since</label>
                </b-col>
                <b-col md="5">
                  <validation-provider name="Established Since"
                                       rules="numeric"
                                       v-slot="validationContext">
                    <b-form-input id="companyEstablishedYear"
                                  v-model="company.companyEstablishedYear"
                                  :state="getValidationState(validationContext)"></b-form-input>
                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>

                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="addressLine1">Company Address</label>
                </b-col>
                <b-col md="5">
                  <validation-provider name="Address Line 1"
                                       rules="required"
                                       v-slot="validationContext">
                    <b-form-input id="addressLine1"
                                  v-model="company.addressLine1"
                                  :state="getValidationState(validationContext)"></b-form-input>
                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                </b-col>
                <b-col md="5">
                  <b-form-input id="addressLine2"
                                v-model="company.addressLine2"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                </b-col>
                <b-col md="5">
                  <b-form-input id="addressLine3"
                                v-model="company.addressLine3"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                </b-col>
                <b-col md="5">
                  <b-form-input id="addressLine4"
                                v-model="company.addressLine4"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                </b-col>
                <b-col md="5">
                  <b-form-input id="addressLine5"
                                v-model="company.addressLine5"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="addressTown">Town</label>
                </b-col>
                <b-col md="5">
                  <b-form-input id="addressTown"
                                v-model="company.addressTown"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="addressCounty">County</label>
                </b-col>
                <b-col md="5">
                  <b-form-input id="addressCounty"
                                v-model="company.addressCounty"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="Postcode">Postcode</label>
                </b-col>
                <b-col md="2">
                  <validation-provider name="Postcode"
                                       rules="required"
                                       v-slot="validationContext">
                    <b-form-input id="Postcode"
                                  v-model="company.postcode"
                                  :state="getValidationState(validationContext)"></b-form-input>
                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="regions">Region</label>
                </b-col>
                <b-col md="3">
                  <validation-provider name="Regions"
                                       rules="required"
                                       v-slot="validationContext">
                      <b-form-select id="regionId"
                                 :options="lookups.regions"
                                 v-model="company.regionId"
                                 value-field="id"
                                 text-field="name"
                                 :state="getValidationState(validationContext)"></b-form-select>
                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                  
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="isPropertyLeased">Property Ownership</label>
                </b-col>
                <b-col md="5">
                  <b-form-radio v-model="company.isPropertyLeased" name="isPropertyLeased" :value="false">Freehold</b-form-radio>
                  <b-form-radio v-model="company.isPropertyLeased" name="isPropertyLeased" :value="true">Leasehold</b-form-radio>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="propertyLeaseDetails">Details</label>
                </b-col>
                <b-col md="5">
                  <b-form-textarea id="propertyLeaseDetails"
                                   v-model="company.propertyLeaseDetails"></b-form-textarea>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="websiteUrl">Website</label>
                </b-col>
                <b-col md="5">
                  <b-form-input id="websiteUrl"
                                v-model="company.websiteUrl"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="guocompanyName">GUO Name</label>
                </b-col>
                <b-col md="5">
                  <b-form-input id="guocompanyName"
                                v-model="company.guocompanyName"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="auditorName">Auditor Name</label>
                </b-col>
                <b-col md="5">
                  <b-form-input id="auditorName"
                                v-model="company.auditorName"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="postcode">Tier</label>
                </b-col>
                <b-col md="3">
                  <b-form-select id="companyTierId"
                                 :options="lookups.companyTiers"
                                 v-model="company.companyTierId"
                                 value-field="id"
                                 text-field="randdName"></b-form-select>
                </b-col>
              </b-row>

              <SubHeader title="Contact Details" />

              <b-row class="my-1">
                <b-col md="3" class="title">
                  <label for="tradingAsName">Title</label>
                </b-col>
                <b-col md="2">
                  <validation-provider name="Title"
                                       :rules="{ required: validateContact()}"
                                       v-slot="validationContext">
                    <b-form-select id="title"
                                   v-model="company.title"
                                   :options="titles"
                                   :state="getValidationState(validationContext)">
                    </b-form-select>
                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="firstName">First Name</label>
                </b-col>
                <b-col md="5">
                  <validation-provider name="First Name"
                                       :rules="{ required: validateContact()}"
                                       v-slot="validationContext">
                    <b-form-input id="firstName"
                                  v-model="company.firstName"
                                  :state="getValidationState(validationContext)"></b-form-input>
                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="lastName">Last Name</label>
                </b-col>
                <b-col md="5">
                  <validation-provider name="Last Name"
                                       :rules="{ required: validateContact()}"
                                       v-slot="validationContext">
                    <b-form-input id="lastName"
                                  v-model="company.lastName"
                                  :state="getValidationState(validationContext)"></b-form-input>
                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="telephoneBusiness">Business</label>
                </b-col>
                <b-col md="3">
                  <!-- <validation-provider
                    name="Business"
                    rules="number"
                    v-slot="validationContext"> -->
                  <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                      <font-awesome-icon icon="phone" />
                    </b-input-group-prepend>
                    <b-form-input id="telephoneBusiness"
                                  v-model="company.telephoneBusiness"
                                  type="number"></b-form-input>
                    <!-- <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback> -->
                  </b-input-group>
                  <!-- </validation-provider> -->
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="telephoneMobile">Mobile</label>
                </b-col>
                <b-col md="3">
                  <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                      <font-awesome-icon icon="phone" />
                    </b-input-group-prepend>
                    <b-form-input id="telephoneMobile" v-model="company.telephoneMobile"
                                  type="number"></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="telephoneAlternative">Alternative</label>
                </b-col>
                <b-col md="3">
                  <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                      <font-awesome-icon icon="phone" />
                    </b-input-group-prepend>
                    <b-form-input id="telephoneAlternative" v-model="company.telephoneAlternative" type="number"></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3" class="label">
                  <label for="emailAddress">Email Address</label>
                </b-col>
                <b-col md="5">
                  <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                      <font-awesome-icon icon="envelope" />
                    </b-input-group-prepend>
                    <b-form-input id="emailAddress" v-model="company.emailAddress"></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col md="3">
                  <label for="input-none"></label>
                </b-col>
                <b-col md="9">
                  <b-button type="submit" variant="success" class="margin-right">
                    <font-awesome-icon icon="save" /> Save
                  </b-button>
                  <b-button @click="newCompany()" variant="danger">
                    <font-awesome-icon icon="times" /> Cancel Changes
                  </b-button>
                </b-col>
              </b-row>


            </b-card>
          </div>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
  import SubHeader from "@/components/shared/SubHeader.vue";
  import LookupsService from '@/services/Lookups.service'
  import CompanyService from '@/services/Company.service';
  import { extend } from 'vee-validate';

  extend('registeredNumberUnknown', {
    params: ['registeredNumber', 'registeredNumberUnknown'],
    validate(value, { registeredNumber, registeredNumberUnknown }) {
      return (registeredNumber == "" && registeredNumberUnknown == true) || (registeredNumber != "" && registeredNumberUnknown == false);
    },
    message: 'Enter a Registered Number OR select Registered Number Unknown',
    computesRequired: true
  });

  export default {
    components: { SubHeader },
    created() {
      LookupsService.loadLookups().then((result) => {
        this.lookups = result.data;
      });
    },
    data() {
      return {
        lookups: {},
        company: {
          companyName: null,
          companyTierId: 0,
          tradingAsName: null,
          registeredNumber: "",
          registeredNumberUnknown: false,
          companyEstablishedYear: null,
          addressLine1: null,
          addressLine2: null,
          addressLine3: null,
          addressLine4: null,
          addressLine5: null,
          addressTown: null,
          addressCounty: null,
          postcode: null,
          isPropertyLeased: null,
          propertyLeaseDetails: null,
          websiteUrl: null,
          guocompanyName: null,
          auditorName: null,
          title: null,
          firstName: null,
          lastName: null,
          emailAddress: null,
          telephoneBusiness: null,
          telephoneMobile: null,
          telephoneAlternative: null
        },
        titles: ["", "Mr", "Miss", "Mrs", "Ms", "Dr"],
      }
    },
    methods: {
      onSubmit() {

        CompanyService.saveCompany(this.company).then(result => {
          this.$router.push("/company/" + result.data);
        })
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      validateContact() {
        if (this.company.firstName || this.company.lastName || (this.company.title != "" && this.company.title != null)) {
          return true;
        }
        return false;
      },
      newCompany() {
        console.log("New Company");
        this.company = {
          companyName: null,
          companyTierId: 0,
          tradingAsName: null,
          registeredNumber: "",
          registeredNumberUnknown: false,
          companyEstablishedYear: null,
          addressLine1: null,
          addressLine2: null,
          addressLine3: null,
          addressLine4: null,
          addressLine5: null,
          addressTown: null,
          addressCounty: null,
          postcode: null,
          isPropertyLeased: null,
          propertyLeaseDetails: null,
          websiteUrl: null,
          guocompanyName: null,
          auditorName: null,
          title: null,
          firstName: null,
          lastName: null,
          emailAddress: null,
          telephoneBusiness: null,
          telephoneMobile: null,
          telephoneAlternative: null
        }
      }
    }
  }

</script>
